export default "__VITE_ASSET__DSj2tPj8__"